import gql from 'graphql-tag';

export default gql`
  mutation applyOneLessonTemplateMutation(
    $course: MongoID!
    $isCopyLessonsToTheEndOfBoard: Boolean
    $lessonTemplate: MongoID!
    $student: MongoID
    $courseCategory: MongoID
    $mainTemplate: MongoID
  ) {
    applyOneLessonTemplateMutation(
      course: $course
      isCopyLessonsToTheEndOfBoard: $isCopyLessonsToTheEndOfBoard
      lessonTemplate: $lessonTemplate
      student: $student
      courseCategory: $courseCategory
      mainTemplate: $mainTemplate
    ) {
      status
    }
  }
`;
